import React from "react";
import styles from "./NavBar.module.scss";
import classNames from "classnames";
import { Link } from "react-router-dom";
import Button from "../UI/Buttons/Button/Button";
import CloseIcon from "@rsuite/icons/Close";

type Props = {};

const DefaultLinkArray = [
  { label: "PROFIL", link: "/profile" },
  { label: "PORUDŽBINE", link: "/order-processing" },
  { label: "LOYALTY TRANSAKCIJE", link: "/loyalty-transactions" },
];

const DriverLinkArray = [
  { label: "PROFIL", link: "/profile" },
  { label: "PORUDŽBINE", link: "/order-processing" },
  { label: "DOSTAVLJENE PORUDŽBINE", link: "/delivery-history" },
  { label: "LOYALTY TRANSAKCIJE", link: "/loyalty-transactions" },
];

function NavBar({ showNavbar, setShowNavbar }: any) {
  return (
    <div
      className={classNames(styles.navBarWrap, {
        [styles.open]: showNavbar,
      })}
    >
      <div
        onClick={() => setShowNavbar(false)}
        className={classNames(styles.overlay, {
          [styles.open]: showNavbar,
        })}
      />
      <div className={styles.content}>
        <div className={styles.header}>
          <img className={styles.logo} src="/logo.png" />

          <CloseIcon
            height={24}
            width={24}
            onClick={() => setShowNavbar(false)}
          />
        </div>

        <div className={styles.accountDetails}>
          <img className={styles.profileImage} src={"/profile.png"} />
          <div className={styles.doctorName}>
            {/* {doctorDetails?.firstName} {doctorDetails?.secondName} */}
            <br />
            <span style={{ fontWeight: "normal", fontSize: "12px" }}>
              {/* Broj licence: <b>{doctorDetails?.licenceNumber}</b> */}
            </span>
          </div>
        </div>
        <hr style={{ margin: "10px 0" }} />

        <div className={styles.linksWrap}>
          {(localStorage.getItem("roles")?.includes("DELIVERY_USER")
            ? DriverLinkArray
            : DefaultLinkArray
          ).map((item, i) => (
            <LinkWrap
              onClick={() => setShowNavbar(false)}
              label={item?.label}
              link={item?.link}
              key={i}
            />
          ))}
        </div>
        <hr style={{ margin: "10px 0" }} />

        <Button
          onClick={() => {
            localStorage.clear();
            window.location.reload();
          }}
          buttonType="white"
        >
          Odjavi se
        </Button>
      </div>
    </div>
  );
}

export default NavBar;

const LinkWrap = ({ label, link, onClick }: any) => {
  return (
    <Link onClick={onClick} className={styles.link} to={link}>
      {label}
    </Link>
  );
};
